import { Accordion, AccordionDetails, AccordionSummary, Box, Drawer, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState, useCallback, useEffect } from "react";
import CalculatorResults from "../calculator/tour/calculatorResults";
import { VEHICLE } from "../../data/data";

const PastTourCard = ({data, loadAllTours}) => {
    const theme = useTheme();

    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const [expanded, setExpanded] = useState(false);
    const [drawerExpanded, setDrawerExpanded] = useState(false);

    useEffect(() => {console.log(data)}, [data]);

    const viewPastTourDetails = useCallback((e, expanded) => {
        if(isMdUp){
            setExpanded(expanded);
        }
        else{
            setDrawerExpanded(true);
        }
    }, [isMdUp]);

    const getVehicleImage = useCallback(() => {
        let vehicle = VEHICLE[0].logoColor;

        for(let i = 0; i < VEHICLE.length; i++){
            if(VEHICLE[i].value === data?.vehicle){
                vehicle = VEHICLE[i].logoColor;
                break;
            }
        }

        return vehicle;
    }, [data]);

    return (
        <>
            <Accordion
                elevation={3}
                sx={{
                    py: {xs: 0, md: 0.5},
                    px: {xs: 0, md: 2},
                }}
                onChange={viewPastTourDetails}
                expanded={expanded}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        width={{xs: '90%', md: '75%'}}
                        container
                    >
                        <Grid size={3}>
                            <Box
                                sx={{
                                    width: {xs: '35px', md: '50px'}
                                }}
                            >
                                <img 
                                    src={getVehicleImage()} 
                                    alt={data?.vehicle} 
                                    width='100%'
                                />
                            </Box>
                        </Grid>

                        <Grid size={6}>
                            <Typography
                                fontWeight={400}
                                fontSize={{xs: 16, md: 18}}
                                letterSpacing={0.3}
                                color="#5E5959"
                                textAlign='left'
                            >
                                {`${data?.tripName ?? 'Unknown Trip'}`}
                            </Typography>
                        </Grid>

                        <Grid size={3}>
                            <Typography
                                fontWeight={400}
                                fontSize={{xs: 16, md: 18}}
                                letterSpacing={0.3}
                                color="#5E5959"
                                textAlign='left'
                            >
                                {data?.month}
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>

                <AccordionDetails>
                    <CalculatorResults 
                        backToFilterView={() => {}}
                        summaryData={data}
                        loadAllTours={loadAllTours}
                    />
                </AccordionDetails>
            </Accordion>

            <Drawer
                anchor='bottom'
                open={drawerExpanded}
                onClose={() => setDrawerExpanded(false)}
                slotProps={{
                    paper: {
                        square: false,
                        style: {
                            borderRadius: '16px 16px 0px 0px'
                        }
                    },
                }}
            >
                <Typography
                    fontWeight={700}
                    fontSize={25}
                    letterSpacing={0.3}
                    color={theme.palette.primary.main}
                    sx={{
                        pl: 3,
                        pt: 2
                    }}
                >
                    {data?.month}
                </Typography>

                <CalculatorResults 
                    backToFilterView={() => {}}
                    summaryData={data}
                    loadAllTours={loadAllTours}
                />
            </Drawer>
        </>
    );
}

export default PastTourCard;